import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const RmListReport = ({
  fetchRmTicketReport,
  rmTicket,
  rmTicketFilter,
  getRmTicketsFilterDropDown,
}) => {
  const headers = [
    'Ticket ID',
    'Created On',
    'Assigned To',
    'Site Number',
    'Client Name',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
        setIsRoleId(roles);
      })();
    }, 1000);
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchRmTicketReport(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      if (fetchRmTicketReport) {
        setIsLoading(true);
        await fetchRmTicketReport();
        await getRmTicketsFilterDropDown();
        setIsLoading(false);
      }
    })();
  }, [fetchRmTicketReport]);

  const onPageChange = async (val) => { 
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await fetchRmTicketReport(filter,val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'View Details', link: '/dashboard/rm-view-report' },
    ];

    const actions = [
      { name: 'View Details', link: '/dashboard/rm-view-report' },
    ];

    const tableData = [
      'id',
      'created_ats',
      'assigned_to',
      'site_no',
      'client_name',
      'status',
    ];
    if (rmTicket && rmTicket.resultSets) {
      const data = rmTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            created_ats: element.created_at,
            Action: isRoleId === 9 ? actions : actions1,
          }
        )
      );
      if (data.length > 0) {
        setListData(data);
      }

      setPageCount(Math.ceil(rmTicket.total / rmTicket.per_page));
    }
  }, [rmTicket]);

  return (
    <Layout
      title={localization.reactiveMaintenance}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={rmTicket?.from}
        onPageChange={onPageChange}
        detailList={rmTicket && rmTicket.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={0}
        listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
        rmTicketFilter
      />
    </Layout>
  );
};

export default RmListReport;
